var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('zf-alert',{attrs:{"alignment":"center","type":"error"}},[_vm._v(_vm._s(_vm.errorMessage))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }